import React from 'react';

import {
  FeatureCategories,
  TypesFilterItemType,
  TypesFilterItems,
} from 'src/modules/designStudio/constants';
import {
  MenuItemType,
  MenuItems,
} from 'src/modules/designStudio/constants/hardCodedData/textureData';
import { Color } from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../../providers/HistoryProvider';
import { ThumbnailList } from '../../ThumbnailList';

export const TypeFilter = ({
  previousColor = '',
  designConfigCategory,
  selectedMenuItem,
  updateDesign,
}: {
  previousColor: Color;
  designConfigCategory: FeatureCategories;
  selectedMenuItem?: MenuItemType;
  updateDesign: UpdateDesignFunction;
}) => {
  const types = new Set<TypesFilterItemType>();
  const filterTitle = `${
    designConfigCategory === FeatureCategories.WALL ? 'Siding' : 'Roofing'
  } Types`;

  const onPress = (id: string) => {
    const defaultTexture = MenuItems.find(item => item.type === id);

    if (!defaultTexture) return;

    const shouldResetColor = !!defaultTexture.thumbnail;

    updateDesign({
      category: designConfigCategory,
      update: {
        textureId: defaultTexture.textureId,
        // Must apply white color to textures that already have colors, otherwise you'll have a color overlay ontop of the texture
        color: shouldResetColor ? '#ffffff' : previousColor,
      },
      trackingData: {
        product: selectedMenuItem?.category ?? '',
        parameter: filterTitle,
        // the Color type does not exist within Segment generated types
        selection: defaultTexture.textureId,
      },
    });
  };

  MenuItems.forEach(item => {
    if (item.category === designConfigCategory) {
      const typesItem = TypesFilterItems.find(
        filterItems => filterItems.id === item.type,
      );
      if (typesItem) {
        types.add(typesItem);
      }
    }
  });

  const typeItems = Array.from(types);
  const orderedTypes = typeItems.sort(
    (a, b) => TypesFilterItems.indexOf(a) - TypesFilterItems.indexOf(b),
  );
  const selectedId = selectedMenuItem?.type;

  return (
    <ThumbnailList
      items={orderedTypes}
      onPress={onPress}
      selectedId={selectedId}
      title={filterTitle}
    />
  );
};
